export default {"src":"/_next/static/media/pipedrive.a6e3f332.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};